/**
 * Breadcrumb.jsx
 *
 * @Author: zhangce
 * @Date: 18/1/23 下午2:42
 */

import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Breadcrumb
 * */
class Breadcrumb extends React.PureComponent {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 分隔符
     * */
    separator: PropTypes.node,
  };

  static defaultProps = {
    prefixCls: 'ne-breadcrumb',
    separator: '/',
  };

  render() {
    const { prefixCls, className, separator, children, ...other } = this.props;
    const classes = classNames(prefixCls, className);
    const items = Children.map(children, item => {
      if (isValidElement(item)) {
        return cloneElement(item, {
          separator: item.props.className || separator,
        });
      }
    });
    return (
      <div className={classes} {...other}>
        {items}
      </div>
    );
  }
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/breadcrumb/Breadcrumb.jsx